var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPininline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  viewBox: "0 0 9 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.5,
  d: "M1.09854 3.09665C1.89817 -0.368216 7.10591 -0.364215 7.90148 3.10065C8.36827 5.13316 7.08561 6.85359 5.96126 7.91785C5.14539 8.69405 3.85462 8.69405 3.03469 7.91785C1.9144 6.85359 0.631747 5.12916 1.09854 3.09665Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.5,
  d: "M4.49988 5.07312C5.1993 5.07312 5.7663 4.51423 5.7663 3.82481C5.7663 3.13538 5.1993 2.5765 4.49988 2.5765C3.80045 2.5765 3.23346 3.13538 3.23346 3.82481C3.23346 4.51423 3.80045 5.07312 4.49988 5.07312Z"
})));
export default SvgPininline;